import React, { useState, useEffect, useRef } from 'react';
import {
  Typography,
  Container,
  Paper,
  TextField,
  Button,
  CircularProgress,
  Box,
  InputAdornment,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SearchIcon from '@mui/icons-material/Search';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import CreateIcon from '@mui/icons-material/Create';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import SendIcon from '@mui/icons-material/Send';
import MessageIcon from '@mui/icons-material/Message';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {
  obtenerListaUsuarios,
  obtenerUsuarioConImagen,
} from '../../actions/UsuariosAction';
import { useStateValue } from '../../contexto/store';
import {
  enviarMensajeUsu,
  obtenerNotasNoLeidas,
} from '../../actions/NotasAction';
import { enviarArchivo } from '../../actions/ArchivosAction';

const NuevaNota = () => {
  const [term, setTerm] = useState('');
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  let mounted = useRef(true);
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [nuevaNota, setNuevaNota] = useState({
    Texto: '',
  });
  const [usuarios, setUsuarios] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [para, setPara] = useState({
    destinatario: '',
  });
  const [de, setDe] = useState({
    remitente: '',
  });
  function searchingTerm(term) {
    return function (x) {
      let NOMBRECOMPLETO = '';
      if (x.NOMBRECOMPLETO === null) {
        NOMBRECOMPLETO = '';
      } else {
        NOMBRECOMPLETO = x.NOMBRECOMPLETO;
      }

      return NOMBRECOMPLETO.toLowerCase().includes(term.toLowerCase()) || !term;
    };
  }
  const abrirDialogNota = (usuario) => {
    setPara({
      destinatario: usuario.UserName,
    });
    setDe({
      remitente: sesionUsuario.usuario.userName,
    });
    setOpenDialog(true);
  };
  const cerrarDialogNota = () => {
    setOpenDialog(false);
    setNuevaNota({
      Texto: '',
    });
  };
  const nuevaNotaHandleChange = (e) => {
    const { name, value } = e.target;
    setNuevaNota((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const enviarNota = () => {
    enviarArchivo(file, fileName).then((response) => {
      if (response.status === 200) {
        let objeto = {
          RemitenteUserName: de.remitente,
          DestinatarioUserName: para.destinatario,
          DIFUSION: 'NO',
          Texto: nuevaNota.Texto,
          ArchivoUrl: response.data,
        };
        enviarMensajeUsu(objeto).then((response) => {
          if (response.status === 200) {
            dispatch({
              type: 'OPEN_SNACKBAR',
              openMensaje: {
                open: true,
                mensaje: ' Se envio la Nota al destinatario ',
              },
            });
            let objetoNota = {
              USUARIOASIGNADO: objeto.DestinatarioUserName,
              UserName: objeto.DestinatarioUserName,
            };
            obtenerNotasNoLeidas(objetoNota);
          } else {
            dispatch({
              type: 'OPEN_SNACKBAR',
              openMensaje: {
                open: true,
                mensaje: 'Errores al intentar enviar nota ',
              },
            });
          }
        });
      }
    });
    setOpenDialog(false);
    setNuevaNota({
      Texto: '',
    });
  };
  useEffect(() => {
    if (mounted.current) {
      obtenerListaUsuarios().then((response) => {
        if (response.status === 200) {
          response.data.map((usuario) => {
            obtenerUsuarioConImagen(usuario.userName).then((response) => {
              setUsuarios((anterior) => [
                ...anterior,
                {
                  UserName: response.data.userName,
                  Token: response.data.token,
                  Email: response.data.email,
                  NOMBRECOMPLETO: response.data.nombrecompleto,
                  imagenPerfil: response.data.imagenPerfil,
                },
              ]);
            });
            return null;
          });
          setDatosCargados(true);
        } else {
          console.log('no cargo usuarios');
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, []);
  const saveFile = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 4,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <NoteAddIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Nueva Nota
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.9)', mt: 0.5 }}
            >
              Enviar mensaje a otro usuario
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            name="term"
            onChange={(e) => setTerm(e.target.value)}
            label="Buscar Usuario"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Dejar Nota a:
        </Typography>
        {datosCargados ? (
          <List sx={{ mb: 2 }}>
            {usuarios.filter(searchingTerm(term)).map((usuario) => (
              <Box
                key={usuario.UserName}
                sx={{
                  mb: 2,
                  p: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 2,
                  '&:hover': {
                    backgroundColor: 'action.hover',
                  },
                }}
              >
                <ListItem sx={{ px: 0 }}>
                  <ListItemAvatar>
                    <Avatar alt="Profile Picture" src={usuario.imagenPerfil} />
                  </ListItemAvatar>
                  <Typography sx={{ flex: 1, fontWeight: 500 }}>
                    {usuario.NOMBRECOMPLETO}
                  </Typography>
                  <Tooltip title="Redactar Nota">
                    <IconButton
                      onClick={() => abrirDialogNota(usuario)}
                      sx={{
                        backgroundColor: 'primary.main',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: 'primary.dark',
                        },
                      }}
                    >
                      <CreateIcon />
                    </IconButton>
                  </Tooltip>
                </ListItem>
              </Box>
            ))}
          </List>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography>Cargando...</Typography>
          </Box>
        )}
      </Paper>

      <Dialog
        open={openDialog}
        onClose={cerrarDialogNota}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          Nueva nota para: {para.destinatario}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>Redactar nota:</DialogContentText>
          <TextField
            fullWidth
            name="Texto"
            value={nuevaNota.Texto}
            autoFocus
            multiline
            rows={4}
            variant="outlined"
            placeholder="Escriba su mensaje aquí..."
            onChange={nuevaNotaHandleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ alignSelf: 'flex-start', mt: 2 }}>
                  <MessageIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                </InputAdornment>
              ),
            }}
          />
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              component="label"
              startIcon={<AttachFileIcon />}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              {fileName || 'Adjuntar Archivo'}
              <input type="file" hidden onChange={saveFile} />
            </Button>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={cerrarDialogNota}
            variant="outlined"
            color="primary"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={enviarNota}
            color="primary"
            startIcon={<SendIcon />}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Enviar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};
export default NuevaNota;
